const FreightsRoutes = {
  create: "/create",
  get: "/get",
  update: "/update",
};

export default FreightsRoutes;
